export const ChartType = {
  BAR: "ColumnChart",
  AREA: "AreaChart",
  BUBBLE: "BubbleChart",
  PIE: "PieChart",
  GANTT: "Gantt",
  GAUGE: "Gauge",
  COMBO: "ComboChart",
  TIMELINE: "Timeline"
};

export const DisplayType = {
  CHART: "Chart",
  TABLE: "TABLE",
  TABLECHART: "TABLECHART"
};



// WEBPACK FOOTER //
// ./src/components/Common/Statistics/ChartObjects.js